import SvgIcon from "@/components/common/SvgIcon";
import { EOsTypeEnum } from "@/types";

export const industryOptions = [
  "IT & Tech",
  "Healthcare",
  "Finance & Banking",
  "Government",
  "Retail & E-commerce",
  "Manufacturing",
  "Logistics & Transportation",
  "Other",
];

export const regionalList = [
  { value: "us", title: "us.trio.so" },
  { value: "eu", title: "eu.trio.so" },
  // { value: "sa", title: ".sa" },
];
export const osTypeOptions = [
  {
    icon: <SvgIcon iconName="AndroidOs" />,
    label: "Android",
    value: EOsTypeEnum.ANDROID,
    platformIcon: (
      <SvgIcon
        width={12}
        height={12}
        fill="fill-gray-300"
        iconName="AndroidOs"
      />
    ),
  },
  {
    icon: <SvgIcon iconName="Mac" />,
    label: "iOS",
    value: EOsTypeEnum.IOS,
    platformIcon: (
      <SvgIcon width={12} height={12} fill="fill-gray-200" iconName="apple" />
    ),
  },
  {
    icon: <SvgIcon iconName="window" />,
    label: "Windows",
    value: EOsTypeEnum.WINDOWS,
    platformIcon: (
      <SvgIcon width={12} height={12} iconName="windowCollection" />
    ),
  },
  {
    icon: <SvgIcon iconName="ios" />,
    label: "macOS",
    value: EOsTypeEnum.MACOS,
    platformIcon: <SvgIcon fill="fill-gray-200" iconName="apple" />,
  },
  {
    icon: <SvgIcon iconName="ipad" />,
    label: "iPadOS",
    value: EOsTypeEnum.IPADOS,
    platformIcon: <SvgIcon fill="fill-gray-200" iconName="apple" />,
  },
];
